import React from "react";
import Draggable from "react-draggable";
import ReactTooltip from "react-tooltip";
import "../mobileRecom.css";
import { sanitizeHtml } from "../../common/components/SafeHtml";

const MobileTableSummary = ({ toggleTableSummary, getTableSummaryDataResponse }) => {
    return (
        <div
            className="modal modal-region modal-view modal-table-summary mobile-recom-summary-table-modal"
            id="modalId"
            style={{ display: "block" }}
            tabIndex="-1"
        >
            <Draggable handle=".draggable" cancel=".not-draggable">
                <div className="modal-dialog" role="document">
                    <div className="modal-content">
                        <ReactTooltip
                            id="search_replace"
                            effect="solid"
                            className="rc-tooltip-custom-class"
                            backgroundColor="#007bff"
                            place="left"
                            html={true}
                            getContent={dataTip => (dataTip ? sanitizeHtml(dataTip) : "")}
                        />

                        <div className="modal-header draggable">
                            <h5 className="modal-title" id="exampleModalLabel">
                                <div className="txt-hed">Table Summary</div>
                            </h5>
                            <div className="not-draggable">
                                <button type="button" className="close" onClick={toggleTableSummary}>
                                    <span aria-hidden="true">
                                        <img src="/img/close.svg" alt="" />
                                    </span>
                                </button>
                            </div>
                        </div>
                        <div className="modal-body region-otr">
                            <div className="wrapper-survey-detail">
                                <ul className="wrapper-survey-list">
                                    {getTableSummaryDataResponse?.recommendation_status && (
                                        <li>
                                            <strong>Recommendation Status:</strong>
                                            <ul>
                                                {Object.entries(getTableSummaryDataResponse?.recommendation_status || {})?.length > 0 ? (
                                                    Object.entries(getTableSummaryDataResponse?.recommendation_status || {})?.map(([key, value]) => (
                                                        <li>
                                                            {key} : <span>{value}</span>
                                                        </li>
                                                    ))
                                                ) : (
                                                    <li>N/A</li>
                                                )}
                                            </ul>
                                        </li>
                                    )}
                                    <li>
                                        <strong>Recommendation Source:</strong>
                                        <ul>
                                            {Object.entries(getTableSummaryDataResponse?.recommendation_source_type || {})?.length > 0 ? (
                                                Object.entries(getTableSummaryDataResponse?.recommendation_source_type || {})?.map(([key, value]) => (
                                                    <li key={key}>
                                                        {key}: <span>{value}</span>
                                                    </li>
                                                ))
                                            ) : (
                                                <li>N/A</li>
                                            )}
                                        </ul>
                                    </li>

                                    <li>
                                        <strong>Recommendation Type:</strong>
                                        <ul>
                                            {Object.entries(getTableSummaryDataResponse?.recommendation_type || {})?.length > 0 ? (
                                                Object.entries(getTableSummaryDataResponse?.recommendation_type || {})?.map(([key, value]) => (
                                                    <li key={key}>
                                                        {key}: <span>{value}</span>
                                                    </li>
                                                ))
                                            ) : (
                                                <li>N/A</li>
                                            )}
                                        </ul>
                                    </li>

                                    <li>
                                        <strong>Recommendation Narrative:</strong>
                                        <ul>
                                            {Object.entries(getTableSummaryDataResponse?.recommendation_narrtive || {})?.length > 0 ? (
                                                Object.entries(getTableSummaryDataResponse?.recommendation_narrtive || {})?.map(([key, value]) => (
                                                    <li key={key}>
                                                        {key}: <span>{value}</span>
                                                    </li>
                                                ))
                                            ) : (
                                                <li>N/A</li>
                                            )}
                                        </ul>
                                    </li>

                                    <li>
                                        <strong>Media Count:</strong>
                                        <ul>
                                            <li>
                                                Images: <span>{getTableSummaryDataResponse?.images_count ?? 0}</span>
                                            </li>
                                            <li>
                                                Audio: <span>{getTableSummaryDataResponse?.audio_count ?? 0}</span>
                                            </li>
                                            <li>
                                                Video: <span>{getTableSummaryDataResponse?.video_count ?? 0}</span>
                                            </li>
                                        </ul>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </Draggable>
        </div>
    );
};

export default MobileTableSummary;
